<template>
  <div>
    <v-dialog v-model="exibir" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Solicitação de
            <span v-if="tipo==='ESCLARECIMENTO'">Esclarecimento</span>
            <span v-else>Impugnação</span>
          </span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm2>
              <div class="az-text">
                <label class="label">Edital</label>
                <div>{{licitacao.numeroEdital}}</div>
              </div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="az-text pl-2" style="word-break: break-word;">
                <label class="label">Objeto</label>
                <div>{{licitacao.objeto}}</div>
              </div>
            </v-flex>
            <v-flex xs12 sm4 d-flex>
              <div class="az-text">
                <label class="label">Pessoa</label>
                <div>
                  <v-radio-group v-model="tipoPessoa" row class="radio-group-esc-imp">
                    <v-radio label="Jurídica" value="J"></v-radio>
                    <v-radio label="Física" value="F"></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 d-flex>
              <div class="az-text pr-3">
                <label v-show="ehPessoaFisica" class="label">Nome</label>
                <v-text-field v-show="ehPessoaFisica"
                              name="Nome" class="required-field pt-0"
                              placeholder="Informe o nome"
                              v-model="nomeRazaoSocial"
                              v-validate="'required'"
                              :error-messages="errors.collect('Nome')"
                ></v-text-field>
                <label v-show="!ehPessoaFisica" class="label">Razão Social</label>
                <v-text-field v-show="!ehPessoaFisica"
                              name="Razão Social" class="required-field pt-0"
                              placeholder="Informe a razão social"
                              v-model="nomeRazaoSocial"
                              v-validate="'required'"
                              :error-messages="errors.collect('Razão Social')"
                ></v-text-field>
              </div>
            </v-flex>
            <v-flex xs12 sm6 d-flex>
              <div class="az-text">
                <label v-show="ehPessoaFisica" class="label">CPF</label>
                <v-text-field v-show="ehPessoaFisica" name="CPF" class="required-field pt-0"
                              v-mask="customMaskCPF" placeholder="Informe o CPF"
                              v-model="cpf" v-validate="'required'"
                              :error-messages="errors.collect('CPF')"
                ></v-text-field>
                <label v-show="!ehPessoaFisica" class="label">CNPJ</label>
                <v-text-field v-show="!ehPessoaFisica" name="CNPJ" class="required-field pt-0"
                              v-mask="customMaskCNPJ" placeholder="Informe o CNPJ"
                              v-model="cnpj" v-validate="'required'"
                              :error-messages="errors.collect('CNPJ')"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 d-flex>
              <div class="az-text pr-3">
                <label class="label">E-mail</label>
                <v-text-field name="E-mail" class="required-field pt-0"
                              placeholder="Informe o e-mail"
                              v-model="email" v-validate="'required'"
                              :error-messages="errors.collect('E-mail')"
                ></v-text-field>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 d-flex>
              <div class="az-text">
                <label class="label">Telefone</label>
                <v-text-field name="Telefone" class="required-field pt-0"
                              placeholder="Informe o telefone"
                              v-mask="customMaskTelefone"
                              v-model="telefone" v-validate="'required'"
                              :error-messages="errors.collect('Telefone')"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 d-flex>
              <div class="az-text">
                <label v-show="tipo === 'ESCLARECIMENTO'" class="label">Assunto Esclarecimento</label>
                <label v-show="tipo === 'IMPUGNACAO'" class="label">Assunto Impugnação</label>
                <v-textarea name="Assunto" class="required-field pt-0"
                              placeholder="Informe o assunto" rows="2"
                              v-model="assunto" v-validate="'required'"
                              :error-messages="errors.collect('Assunto')"
                ></v-textarea>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 d-flex>
              <div class="az-text">
                <label class="label">Anexo</label>
                <edl-file-upload v-if="!anexo" height="76px" ref="azFileUploadRecursoContrarrazao"
                                 :accept="arquivosAceitos"
                                 :repository="repository">
                  <a @click.prevent="$refs.azFileUploadRecursoContrarrazao.openFileSelector()">
                    <v-icon>archive</v-icon>
                    Importar Arquivo
                  </a>
                </edl-file-upload>
                <div v-else style="width: 334px; height: 80px">
                  <span class="anexo-solicitar-esc-imp">
                    {{anexo.nome}}
                    <v-tooltip top>
                      <v-icon slot="activator" size="20px" @click="removerAnexo">close</v-icon>
                      Remover
                    </v-tooltip>
                  </span>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <div id="recaptcha" class="g-recaptcha" data-size="normal"
                   :data-sitekey="reCaptchaSiteKey"></div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout class="justify-space-between">
            <v-btn class="ml-2 mb-2" @click="fecharModal">CANCELAR</v-btn>
            <v-btn class="mr-2 mb-2 primary"
                   @click="abrirModalConfirmarEnvio">
              SOLICITAR
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal-confirmar-etapa-anexo
            v-model="modalConfirmarEnvio"
            :title="'Confirmar Envio'"
            :max-width="'450'"
            :text="mensagemConfirmacao"
            second-text="Esta ação NÃO PODERÁ ser desfeita!"
            @fecharModalConfirm="fecharModalConfirmarEnvio"
            @cancelarAcao="fecharModalConfirmarEnvio"
            @confirmarAcao="solicitar"
    />
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
    name: 'ModalCriarEsclarecimentoImpugnacao',
    components: {
    },
    props: {
        exibir:{
            type: Boolean,
            default: false
        },
        tipo:{
            type: String,
            default: 'ESCLARECIMENTO'
        },
        maxWidth: {
            type: String,
            default: '800'
        },
        licitacaoId:{
            type: Number
        }
    },
    mounted() {
        this.renderizarRecaptcha()
    },
    data() {
        return {
            customMaskTelefone: {
                mask: '(##) #####-####',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            customMaskCNPJ: {
                mask: '##.###.###/####-##',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            customMaskCPF: {
                mask: '###.###.###-##',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            nomeRazaoSocial: null,
            cpf:null,
            cnpj: null,
            email: null,
            telefone: null,
            assunto: null,
            anexo: null,
            modalConfirmarEnvio: false,
            tipoPessoa: 'J'
        }
    },
    computed: {
        ...mapState(['loki', 'licitacao', 'parametros']),
        reCaptchaSiteKey(){
            return this.parametros.reCaptchaSiteKey
        },
        repository() {
            return `repo1:licitacao/${this.licitacaoId}/${this.tipo}/publico`
        },
        mensagemConfirmacao(){
            if(!this.anexo) {
                return 'Atenção, o anexo não foi inserido, deseja continuar?'
            }else{
                const tipo = this.tipo === 'ESCLARECIMENTO' ? 'um esclarecimento' : 'uma impugnação'
                return `Atenção! Você está enviando ${tipo}. Deseja continuar?`
            }
        },
        ehPessoaFisica(){
            return this.tipoPessoa === 'F'
        },
        arquivosAceitos() {
            return this.parametros.extensao
        }
    },
    methods: {
        async abrirModalConfirmarEnvio(){
            const estaValido = await this.validarCampos()
            if(!estaValido){
                await this.$validator.validateAll()
                this.mostrarNotificacaoErro('Preencha todos os campos corretamente')
            }
            if(estaValido){
                this.modalConfirmarEnvio = true
            }
        },
        fecharModalConfirmarEnvio(){
            this.modalConfirmarEnvio = false
        },
        async solicitar(){
            const captchaResponse = grecaptcha.getResponse()
            const payload = {
                nomeRazaoSocial: this.nomeRazaoSocial,
                email: this.email,
                telefone: this.telefone,
                assunto: this.assunto,
                anexo: this.anexo,
                tipo: this.tipo,
                tipoPessoa: this.tipoPessoa,
                cpfCnpj: this.tipoPessoa === 'F'? this.cpf : this.cnpj,
                captcha: captchaResponse
            }
            this.$emit('solicitar', payload)
            this.modalConfirmarEnvio = false
            grecaptcha.reset()
        },
        async validarCampos(){
            if(this.tipoPessoa === 'J'){
                if(!await this.$validator.validate('Razão Social')){return false}
                if(!await this.$validator.validate('CNPJ')){return false}
            }else{
                if(!await this.$validator.validate('Nome')){return false}
                if(!await this.$validator.validate('CPF')){return false}
            }
            if(!await this.$validator.validate('E-mail')){return false}
            if(!await this.$validator.validate('Telefone')){return false}
            return !(!await this.$validator.validate('Assunto'))
        },
        fecharModal() {
            this.$emit('fecharModal')
        },
        removerAnexo(){
            this.anexo = null
            this.resetUploadedFiles()
        },
        isUploadArquivosTemporariosCompleto() {
            return !this.isUploadEmAndamento() && this.loki.uploadedFiles.length > 0
        },
        isUploadEmAndamento() {
            const arquivosEmProgresso = this.loki.uploadFileProgress
            const numeroArquivosEmProgresso = Object.keys(arquivosEmProgresso).length
            if (!numeroArquivosEmProgresso) {
                return false
            }
            let isEmAndamento = false
            Object.keys(arquivosEmProgresso).forEach(chaveArquivo => {
                const arquivo = arquivosEmProgresso[chaveArquivo]
                if (!arquivo.error) {
                    isEmAndamento = true
                }
            })
            return isEmAndamento
        },
        async inserir() {
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Salvando anexos...')
            try {
                this.mostrarDialogConfirmarSaida = false
                this.atualizarListaAnexos()
                this.desabilitarLoadingGlobal()
            } catch (e) {
                this.desabilitarLoadingGlobal()
            }
        },
        atualizarListaAnexos() {
            const anexos = []
            this.loki.uploadedFiles.forEach(item => {
                anexos.push({
                    nome: item.name,
                    status: item.status,
                    uri: item.uri,
                    url: item.url
                })
            })
            if(anexos.length > 1){
                this.mostrarNotificacaoErro('Apenas um arquivo pode ser anexado')
                this.resetUploadedFiles()
            }else{
                this.anexo = anexos[0]
                this.mostrarNotificacaoSucessoDefault()
            }
        },
        renderizarRecaptcha(i=0){
            try {
                grecaptcha.render('recaptcha')
            }catch(e){
                if(i>=4) return
                setTimeout(() => {
                    this.renderizarRecaptcha(i+1)
                }, 1000)
            }
        }
    },
    watch: {
        'loki.uploadedFiles': {
            async handler() {
                if (this.isUploadArquivosTemporariosCompleto()) {
                    await this.inserir()
                }
            }
        }
    },
}
</script>

<style lang="stylus">
.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white

.label
  font-size 14px
  font-weight bold
  color #3A6861 !important

.anexo-solicitar-esc-imp
  background-color #b0b0b0
  border-radius 5px
  padding-left 5px
  padding-right 5px
  margin-top 5px
  display inline-block

.anexo-solicitar-esc-imp:hover
  box-shadow 0 0 4px 1px #c9c9c9

.radio-group-esc-imp.v-input--selection-controls
  margin-top 0

.g-recaptcha
  height 80px !important
  padding-top 31px
  margin-left 10px
</style>
